// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment: Record<
  | 'urlApi'
  | 'linkUrlSite'
  | 'subscriptionKey'
  | 'azureBlobStorage'
  | 'googleMapsApiKey'
  | 'azureTranslatorRegion'
  | 'azureTranslatorSubscriptionKey'
  | 'azureTranslatorEndpoint'
  | 'agrirouterOnboardUrl',
  string
> & {
  environmentName: 'PROD' | 'DEV' | 'STAGE' | 'LOCAL';
  production: boolean;
} = {
  production: false,
  environmentName: 'DEV',
  urlApi: 'https://isofarm-development.azure-api.net/v1/',
  linkUrlSite: 'https://mango-rock-0b1b3db10.3.azurestaticapps.net/',
  subscriptionKey: '3ad4b864ecf945d9bbcbf0af4a9cedb1',
  azureBlobStorage: 'https://isofarmdev.blob.core.windows.net/',
  googleMapsApiKey: 'AIzaSyBshkkJv4XyJqDgXtCajYarHGriopOyQt0',
  azureTranslatorRegion: 'brazilsouth',
  azureTranslatorSubscriptionKey:
    '59yNMzLPqbtJ2pQPjgWUYSPsGXvkvoqsjjmUb6375yNeM7M0YgjdJQQJ99BFACZoyfiXJ3w3AAAbACOGXlYB',
  azureTranslatorEndpoint:
    'https://api.cognitive.microsofttranslator.com/translate?api-version=3.0',
  agrirouterOnboardUrl:
    'https://agrirouter.azurewebsites.net/api/authorization',
};
